export * from './dom/elementContains';
export * from './dom/elementContainsAttribute';
export * from './dom/findElementRecursive';
export * from './dom/getChildren';
export * from './dom/getDocument';
export * from './dom/getParent';
export * from './dom/getRect';
export * from './dom/getVirtualParent';
export * from './dom/getWindow';
export * from './dom/isVirtualElement';
export * from './dom/on';
export * from './dom/portalContainsElement';
export * from './dom/raiseClick';
export * from './dom/setPortalAttribute';
export * from './dom/setVirtualParent';
//# sourceMappingURL=dom.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/@uifabric/utilities/lib/dom.js
// module id = 212
// module chunks = 0